import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Mensajes from "../Mensajes"

class MensajesAll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numMensjaes: 0
    };
  }

  componentDidMount = () => {

  };
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  totalMensajes = (total) => {
    this.setState({ numMensjaes: total });
  }


  render() {
    return (
      <Layout>
        <Mensajes formato={-1} ambito_id={-1} totalMensajes={(e) => this.totalMensajes(e)} />
      </Layout >
    );
  }
}

export default MensajesAll;
